export const SET_LOCATION = 'SET_LOCATION';
export const SET_PLACE = 'SET_PLACE';
export const SEARCH_BY_PLACE = 'SEARCH_BY_PLACE';
export const SELECT_RESTAURANT = 'SELECT_RESTAURANT';
export const SET_TABLE_NUMBER = 'SET_TABLE_NUMBER';
export const SHOW_RESULTS = 'SHOW_RESULTS';
export const HIDE_RESULTS = 'HIDE_RESULTS';
